//Include Both Helper File with needed methods
import { base64toBlob, errorMessage } from "helpers/utils";
import { call, put, select, takeEvery } from "redux-saga/effects";
import formatDataService from "services/FormatDataService";
import {
  createRegistryDelegateFail,
  createRegistryDelegateSuccess,
  createRegistryInvoicesFail,
  createRegistryInvoicesSuccess,
  createRequestInvoiceCodeFail,
  createRequestInvoiceCodeSuccess,
  downloadXmlRegistryDelegateFail,
  downloadXmlRegistryDelegateSuccess,
  downloadXmlRegistryInvoicesFail,
  downloadXmlRegistryInvoicesSuccess,
  downloadXmlRequestInvoiceCodeFail,
  downloadXmlRequestInvoiceCodeSuccess,
  editRegistryDelegateFail,
  editRegistryDelegateSuccess,
  editRegistryInvoicesFail,
  editRegistryInvoicesSuccess,
  editRequestInvoiceCodeFail,
  editRequestInvoiceCodeSuccess,
  getDetailRegistryDelegateFail,
  getDetailRegistryDelegateSuccess,
  getDetailRegistryInvoicesFail,
  getDetailRegistryInvoicesSuccess,
  getDetailRequestInvoiceCodeFail,
  getDetailRequestInvoiceCodeSuccess,
  getListRegistryDelegateFail,
  getListRegistryDelegateSuccess,
  getListRegistryInvoicesFail,
  getListRegistryInvoicesSuccess,
  getListRequestInvoiceCodeFail,
  getListRequestInvoiceCodeSuccess,
  previewPdfFail,
  previewPdfSuccess,
  releaseRegistryDelegateFail,
  releaseRegistryDelegateSuccess,
  releaseRegistryInvoicesFail,
  releaseRegistryInvoicesSuccess,
  releaseRequestInvoiceCodeFail,
  releaseRequestInvoiceCodeSuccess,
  transferUsbFail,
  transferUsbSuccess,
} from "store/actions";
import {
  cancelTaxDeductsFail,
  cancelTaxDeductsSuccess,
  checkInvoicesCurrentFail,
  checkInvoicesCurrentSuccess,
  createTaxDeductsFail,
  createTaxDeductsRegistryFail,
  createTaxDeductsRegistrySuccess,
  createTaxDeductsSuccess,
  deleteTaxDeductsFail,
  deleteTaxDeductsRegistryFail,
  deleteTaxDeductsRegistrySuccess,
  deleteTaxDeductsSuccess,
  downloadPDFInvoicesFail,
  downloadPDFInvoicesSuccess,
  downloadXmlTaxDeductsFail,
  downloadXmlTaxDeductsRegistryFail,
  downloadXmlTaxDeductsRegistrySuccess,
  downloadXmlTaxDeductsSuccess,
  editTaxDeductsFail,
  editTaxDeductsRegistryFail,
  editTaxDeductsRegistrySuccess,
  editTaxDeductsSuccess,
  getDetailTaxDeductsFail,
  getDetailTaxDeductsRegistryFail,
  getDetailTaxDeductsRegistrySuccess,
  getDetailTaxDeductsSuccess,
  getHistoryTransferFail,
  getHistoryTransferSuccess,
  getListTaxDeductsFail,
  getListTaxDeductsRegistryFail,
  getListTaxDeductsRegistrySuccess,
  getListTaxDeductsSuccess,
  getReasonDenyReleaseFail,
  getReasonDenyReleaseSuccess,
  previewPdfRegisterInvoiceFail,
  previewPdfRegisterInvoiceSuccess,
  releaseTaxDeductsFail,
  releaseTaxDeductsRegistryFail,
  releaseTaxDeductsRegistrySuccess,
  releaseTaxDeductsSuccess,
} from "./actions";
// Crypto Redux States
import { ALL_BU, ALL_STORE } from "constants/DashboardContanst";
import { LINK_TYPE } from "constants/TaxDeductConstant";
import {
  CANCEL_TAX_DEDUCTS,
  CHECK_INVOICES_CURRENT,
  CREATE_REGISTRY_DELEGATE,
  CREATE_REGISTRY_INVOICES,
  CREATE_REQUEST_INVOICE_CODE,
  CREATE_TAX_DEDUCTS,
  CREATE_TAX_DEDUCTS_REGISTRY,
  DELETE_TAX_DEDUCTS,
  DELETE_TAX_DEDUCTS_REGISTRY,
  DOWNLOAD_PDF_REGISTRY_INVOICES,
  DOWNLOAD_XML_REGISTRY_DELEGATE,
  DOWNLOAD_XML_REGISTRY_INVOICES,
  DOWNLOAD_XML_REQUEST_INVOICE_CODE,
  DOWNLOAD_XML_TAX_DEDUCTS,
  DOWNLOAD_XML_TAX_DEDUCTS_REGISTRY,
  EDIT_REGISTRY_DELEGATE,
  EDIT_REGISTRY_INVOICES,
  EDIT_REQUEST_INVOICE_CODE,
  EDIT_TAX_DEDUCTS,
  EDIT_TAX_DEDUCTS_REGISTRY,
  GET_DETAIL_REGISTRY_DELEGATE,
  GET_DETAIL_REGISTRY_INVOICES,
  GET_DETAIL_REQUEST_INVOICE_CODE,
  GET_DETAIL_TAX_DEDUCTS,
  GET_DETAIL_TAX_DEDUCTS_REGISTRY,
  GET_HISTORY_TRANSFER,
  GET_LIST_REGISTRY_DELEGATE,
  GET_LIST_REGISTRY_INVOICES,
  GET_LIST_REQUEST_INVOICE_CODE,
  GET_LIST_TAX_DEDUCTS,
  GET_LIST_TAX_DEDUCTS_REGISTRY,
  GET_REASON_DENY_RELEASE,
  PREVIEW_PDF,
  PREVIEW_PDF_REGISTER_INVOICE,
  RELEASE_REGISTRY_DELEGATE,
  RELEASE_REGISTRY_INVOICES,
  RELEASE_REQUEST_INVOICE_CODE,
  RELEASE_TAX_DEDUCTS,
  RELEASE_TAX_DEDUCTS_REGISTRY,
  TRANSFER_USB,
} from "./actionTypes";
function* fetchPreviewPdfRegisterInvoice({ id, typePreview }) {
  try {
    // Call api
    const response = yield call(formatDataService.reviewPdfRegisterInvoice, id);
    if (response.result && response.file) {
      const blob = base64toBlob(response.file);
      const url = URL.createObjectURL(blob);
      yield put(
        previewPdfRegisterInvoiceSuccess({ url: url, typePreview: typePreview })
      );
    } else {
      yield put(previewPdfRegisterInvoiceFail("Không tồn tại file"));
    }
  } catch (error) {
    yield put(previewPdfRegisterInvoiceFail(errorMessage(error)));
  }
}
function* fetchGetRegistryInvoices({ params }) {
  try {
    // console.log("fetchGetListUpload");
    // console.log("params", params);
    // Param
    const perPage = params.sizePerPage;
    const page = params.page;
    const columnFilter = params.columnFilter;
    const keywords = params.keywords;
    const sort = params.sort;
    let { buStoreHeader } = yield select(state => state.Dashboard);
    // Call api
    const response = yield call(
      formatDataService.listRegistryInvoices,
      page,
      perPage,
      columnFilter,
      keywords,
      sort,
      buStoreHeader
    );
    const totalCount = response._meta.totalCount;
    // console.log("response", response);
    yield put(getListRegistryInvoicesSuccess(response.items, totalCount));
  } catch (error) {
    yield put(getListRegistryInvoicesFail(errorMessage(error)));
  }
}

function* fetchGetRegistryDelegate({ params }) {
  try {
    // console.log("fetchGetListUpload");
    // console.log("params", params);
    // Param
    const perPage = params.sizePerPage;
    const page = params.page;
    const columnFilter = params.columnFilter;
    const keywords = params.keywords;
    const sort = params.sort;
    // Call api
    const response = yield call(
      formatDataService.listRegistryDelegate,
      page,
      perPage,
      columnFilter,
      keywords,
      sort
    );
    const totalCount = response._meta.totalCount;
    // console.log("response", response);
    yield put(getListRegistryDelegateSuccess(response.items, totalCount));
  } catch (error) {
    yield put(getListRegistryDelegateFail(errorMessage(error)));
  }
}

function* fetchGetRequestInvoiceCodes({ params }) {
  try {
    // console.log("fetchGetListUpload");
    // console.log("params", params);
    // Param
    const perPage = params.sizePerPage;
    const page = params.page;
    const columnFilter = params.columnFilter;
    const keywords = params.keywords;
    const sort = params.sort;
    // Call api
    const response = yield call(
      formatDataService.listRequestInvoiceCodes,
      page,
      perPage,
      columnFilter,
      keywords,
      sort
    );
    const totalCount = response._meta.totalCount;
    // console.log("response", response);
    yield put(getListRequestInvoiceCodeSuccess(response.items, totalCount));
  } catch (error) {
    yield put(getListRequestInvoiceCodeFail(errorMessage(error)));
  }
}

function* fetchGetDetailRegistryInvoices({ id }) {
  try {
    const response = yield call(formatDataService.detailRegistryInvoices, id);
    // console.log("response", response);
    yield put(getDetailRegistryInvoicesSuccess(response));
  } catch (error) {
    yield put(getDetailRegistryInvoicesFail(errorMessage(error)));
  }
}

function sleep(sec) {
  return new Promise(resolve => setTimeout(resolve, sec * 1000));
}

function* fetchCreateRegistryInvoices({ data }) {
  try {
    let { buStoreHeader } = yield select(state => state.Dashboard);
    const response = yield call(
      formatDataService.createRegistryInvoices,
      data,
      buStoreHeader
    );
    // Wait XML generate
    yield sleep(1);
    yield put(createRegistryInvoicesSuccess(response));
  } catch (error) {
    yield put(createRegistryInvoicesFail(errorMessage(error)));
  }
}

function* fetchEditRegistryInvoices({ data, id }) {
  try {
    const response = yield call(
      formatDataService.editRegistryInvoices,
      data,
      id
    );
    // Wait XML generate
    yield sleep(1);
    yield put(editRegistryInvoicesSuccess(response));
  } catch (error) {
    yield put(editRegistryInvoicesFail(errorMessage(error)));
  }
}

function* fetchGetDetailRegistryDelegate({ id }) {
  try {
    const response = yield call(formatDataService.detailRegistryDelegate, id);
    // console.log("response", response);
    yield put(getDetailRegistryDelegateSuccess(response));
  } catch (error) {
    yield put(getDetailRegistryDelegateFail(errorMessage(error)));
  }
}

function* fetchCreateRegistryDelegate({ data }) {
  try {
    const response = yield call(formatDataService.createRegistryDelegate, data);
    // Wait XML generate
    yield sleep(1);
    yield put(createRegistryDelegateSuccess(response));
  } catch (error) {
    yield put(createRegistryDelegateFail(errorMessage(error)));
  }
}

function* fetchEditRegistryDelegate({ data, id }) {
  try {
    const response = yield call(
      formatDataService.editRegistryDelegate,
      data,
      id
    );
    // Wait XML generate
    yield sleep(1);
    yield put(editRegistryDelegateSuccess(response));
  } catch (error) {
    yield put(editRegistryDelegateFail(errorMessage(error)));
  }
}

function* fetchGetDetailRequestInvoiceCode({ id }) {
  try {
    const response = yield call(formatDataService.detailRequestInvoiceCode, id);
    yield put(getDetailRequestInvoiceCodeSuccess(response));
  } catch (error) {
    yield put(getDetailRequestInvoiceCodeFail(errorMessage(error)));
  }
}

function* fetchCreateRequestInvoiceCode({ data }) {
  try {
    const response = yield call(
      formatDataService.createRequestInvoiceCode,
      data
    );
    // Wait XML generate
    yield sleep(1);
    yield put(createRequestInvoiceCodeSuccess(response));
  } catch (error) {
    yield put(createRequestInvoiceCodeFail(errorMessage(error)));
  }
}

function* fetchEditRequestInvoiceCode({ data, id }) {
  try {
    const response = yield call(
      formatDataService.editRequestInvoiceCode,
      data,
      id
    );
    // Wait XML generate
    yield sleep(1);
    yield put(editRequestInvoiceCodeSuccess(response));
  } catch (error) {
    yield put(editRequestInvoiceCodeFail(errorMessage(error)));
  }
}

function* fetchDownloadXmlRegistryInvoices({
  resource_id,
  fileDownloadName,
  responseType = "blob",
}) {
  try {
    const response = yield call(
      formatDataService.downloadFileXMLRegistryInvoices,
      resource_id,
      responseType
    );
    // console.log("fetchDownloadXmlRegistryInvoices", response);
    if (response) {
      if (responseType === "blob") {
        if (
          response.size > 0 &&
          response.size !== undefined &&
          response.size !== null
        ) {
          const file = URL.createObjectURL(response);

          yield put(
            downloadXmlRegistryInvoicesSuccess(
              null,
              file,
              fileDownloadName + ".xml"
            )
          );
        } else {
          yield put(downloadXmlRegistryInvoicesFail("Download file thất bại"));
        }
      } else {
        // console.log("base64_encode", Buffer.from(response).toString("base64"));
        yield put(
          downloadXmlRegistryInvoicesSuccess(
            Buffer.from(response).toString("base64"),
            null,
            fileDownloadName + ".xml"
          )
        );
      }
      //   yield put(downloadXmlRegistryInvoicesSuccess(response, null, null));
    } else {
      yield put(downloadXmlRegistryInvoicesFail("Download file thất bại"));
    }
  } catch (error) {
    yield put(downloadXmlRegistryInvoicesFail(errorMessage(error)));
  }
}
function* fetchDownloadPDFRegistryInvoices({
  resource_id,
  fileDownloadName,
  downloadType,
  responseType = "blob",
}) {
  try {
    const response = yield call(
      formatDataService.downloadFilePDFRegistryInvoices,
      { resource_id, downloadType, responseType }
    );
    const responseTypeDown = "blob";
    if (response) {
      if (responseTypeDown === "blob") {
        if (response.file) {
          const blob = base64toBlob(response.file);
          const url = URL.createObjectURL(blob);
          yield put(
            downloadPDFInvoicesSuccess(null, url, fileDownloadName + ".pdf")
          );
        } else {
          yield put(downloadPDFInvoicesFail("Download file thất bại"));
        }
      } else {
        // console.log("base64_encode", Buffer.from(response).toString("base64"));
        yield put(
          downloadPDFInvoicesSuccess(
            Buffer.from(response).toString("base64"),
            null,
            fileDownloadName + ".pdf"
          )
        );
      }
      //   yield put(downloadXmlRegistryInvoicesSuccess(response, null, null));
    } else {
      yield put(downloadPDFInvoicesFail("Download file thất bại"));
    }
  } catch (error) {
    yield put(downloadPDFInvoicesFail(errorMessage(error)));
  }
}

function* fetchDownloadXmlRegistryDelegate({
  resource_id,
  fileDownloadName,
  responseType = "blob",
}) {
  try {
    const response = yield call(
      formatDataService.downloadFileXMLRegistryDelegates,
      resource_id,
      responseType
    );
    if (response) {
      if (responseType === "blob") {
        if (
          response.size > 0 &&
          response.size !== undefined &&
          response.size !== null
        ) {
          const file = URL.createObjectURL(response);
          yield put(
            downloadXmlRegistryDelegateSuccess(
              null,
              file,
              fileDownloadName + ".xml"
            )
          );
        } else {
          yield put(downloadXmlRegistryDelegateFail("Download file thất bại"));
        }
      } else {
        // console.log("base64_encode", Buffer.from(response).toString("base64"));
        yield put(
          downloadXmlRegistryDelegateSuccess(
            Buffer.from(response).toString("base64"),
            null,
            fileDownloadName + ".xml"
          )
        );
      }
    } else {
      yield put(downloadXmlRegistryDelegateFail("Download file thất bại"));
    }
  } catch (error) {
    yield put(downloadXmlRegistryDelegateFail(errorMessage(error)));
  }
}

function* fetchDownloadXmlRequestInvoiceCode({
  resource_id,
  fileDownloadName,
  responseType = "blob",
}) {
  try {
    const response = yield call(
      formatDataService.downloadFileXMLRequestInvoiceCode,
      resource_id,
      responseType
    );
    if (response) {
      if (responseType === "blob") {
        if (
          response.size > 0 &&
          response.size !== undefined &&
          response.size !== null
        ) {
          const file = URL.createObjectURL(response);
          yield put(
            downloadXmlRequestInvoiceCodeSuccess(
              null,
              file,
              fileDownloadName + ".xml"
            )
          );
        } else {
          yield put(
            downloadXmlRequestInvoiceCodeFail("Download file thất bại")
          );
        }
      } else {
        // console.log("base64_encode", Buffer.from(response).toString("base64"));
        yield put(
          downloadXmlRequestInvoiceCodeSuccess(
            Buffer.from(response).toString("base64"),
            null,
            fileDownloadName + ".xml"
          )
        );
      }
    } else {
      yield put(downloadXmlRequestInvoiceCodeFail("Download file thất bại"));
    }
  } catch (error) {
    yield put(downloadXmlRequestInvoiceCodeFail(errorMessage(error)));
  }
}

function* fetchReleaseRegistryInvoices({ id }) {
  try {
    const response = yield call(formatDataService.releaseRegistryInvoices, id);
    if (response.result) {
      // Wait
      yield sleep(1);
      yield put(releaseRegistryInvoicesSuccess());
    } else {
      yield put(releaseRegistryInvoicesFail("Gửi phát hành tờ khai thất bại"));
    }
  } catch (error) {
    yield put(releaseRegistryInvoicesFail(errorMessage(error)));
  }
}

function* fetchReleaseRegistryDelegates({ id }) {
  try {
    const response = yield call(formatDataService.releaseRegistryDelegates, id);
    if (response.result) {
      // Wait
      yield sleep(1);
      yield put(releaseRegistryDelegateSuccess());
    } else {
      yield put(releaseRegistryDelegateFail("Gửi phát hành tờ khai thất bại"));
    }
  } catch (error) {
    yield put(releaseRegistryDelegateFail(errorMessage(error)));
  }
}

function* fetchReleaseRequestInvoiceCodes({ id }) {
  try {
    const response = yield call(
      formatDataService.releaseRequestInvoiceCodes,
      id
    );
    if (response.result) {
      // Wait
      yield sleep(1);
      yield put(releaseRequestInvoiceCodeSuccess());
    } else {
      yield put(releaseRequestInvoiceCodeFail("Phát hành đề nghị thất bại"));
    }
  } catch (error) {
    yield put(releaseRequestInvoiceCodeFail(errorMessage(error)));
  }
}

function* fetchPreviewPdf({ resourceId }) {
  try {
    // Call api
    const response = yield call(formatDataService.previewPDF, resourceId);
    if (response) {
      const fileURL = URL.createObjectURL(response);
      yield put(previewPdfSuccess(fileURL));
      // yield put(previewPdfSuccess("PDF"));
    } else {
      yield put(previewPdfFail("Không tồn tại file"));
    }
  } catch (error) {
    yield put(previewPdfFail(errorMessage(error)));
  }
}

function* fetchTransferUsb({
  id,
  typeSend, // TYPE_REGISTER = 1, TYPE_INVOICE = 2
  content,
}) {
  try {
    const data = {
      id,
      type: typeSend,
      content,
    };
    const response = yield call(formatDataService.transfer, data);
    if (response.result) {
      yield put(transferUsbSuccess());
    } else {
      yield put(transferUsbFail(response?.error?.content));
    }
  } catch (error) {
    yield put(transferUsbFail(errorMessage(error)));
  }
}

function* fetchGetReasonDenyRelease({ id, path }) {
  try {
    const response = yield call(formatDataService.errorRelease, id, path);
    if (response.result) {
      yield put(
        getReasonDenyReleaseSuccess(
          response.items.map(item => {
            return {
              code: item.code,
              description: item.description,
            };
          })
        )
      );
    } else {
      yield put(getReasonDenyReleaseFail("ReasonDenyReleaseFail"));
    }
  } catch (error) {
    yield put(getReasonDenyReleaseFail(errorMessage(error)));
  }
}

function* fetchGetHistoryTransfer({ id, path }) {
  try {
    const response = yield call(formatDataService.historyTransfer, id, path);
    if (response.items) {
      yield put(getHistoryTransferSuccess(response.items));
    } else {
      yield put(getHistoryTransferFail("GetHistoryTransfer Fail"));
    }
  } catch (error) {
    yield put(getHistoryTransferFail(errorMessage(error)));
  }
}
function* checkInvoicesCurrent() {
  try {
    const response = yield call(formatDataService.checkInvoicesCurrent);
    if (response) {
      yield put(checkInvoicesCurrentSuccess(response));
    } else {
      yield put(checkInvoicesCurrentFail("CheckInvoicesCurrent Fail"));
    }
  } catch (error) {
    yield put(checkInvoicesCurrentFail(errorMessage(error)));
  }
}

function* fetchGetTaxDeducts({ params }) {
  try {
    // console.log("fetchGetListUpload");
    // console.log("params", params);
    // Param
    const perPage = params.sizePerPage;
    const page = params.page;
    const columnFilter = params.columnFilter;
    const keywords = params.keywords;
    const sort = params.sort;
    let { finalListBuCode, listBuOfTenant, buStoreHeader, buTenantHeaderInfo } =
      yield select(state => state.Dashboard);
    let bu_parent = undefined;
    let bu_code = undefined;
    if (buStoreHeader === ALL_STORE) {
      bu_parent = buTenantHeaderInfo.id;
    } else if (buStoreHeader === ALL_BU) {
      bu_parent = listBuOfTenant
        .filter(item => item.id)
        .map(item => item.id)
        .join(",");
    } else {
      bu_code = buStoreHeader;
    }
    // Call api
    const response = yield call(
      formatDataService.listTaxDeducts,
      page,
      perPage,
      columnFilter,
      keywords,
      sort,
      bu_code,
      bu_parent
    );
    const totalCount = response._meta.totalCount;
    // console.log("response", response);
    yield put(getListTaxDeductsSuccess(response.items, totalCount));
  } catch (error) {
    yield put(getListTaxDeductsFail(error));
  }
}

function* fetchGetDetailTaxDeducts({ id }) {
  try {
    let response = null;
    let responseLink = null;
    response = yield call(formatDataService.detailTaxDeducts, id);
    // console.log("response", response);
    if (response) {
      // Get thông tin hoa don thay the /dieu chinh
      let idRootAdjust = id;
      if (response?.link_type) {
        let isGetChild = false;
        switch (response?.link_type) {
          // Parent có field này
          case LINK_TYPE.PARENT_REPLACE:
          case LINK_TYPE.PARENT_ADJUST:
            isGetChild = true;
            break;
          // Child có field này
          case LINK_TYPE.CHILD_REPLACE:
          case LINK_TYPE.CHILD_ADJUST:
            isGetChild = false;
            break;
          default:
            break;
        }
        responseLink = yield call(formatDataService.getDataLinkTaxDeduct, {
          id: response.id,
          isGetChild,
        });
        if (responseLink) {
          if (isGetChild) {
            response.child = responseLink;
          } else {
            response.root = responseLink;
            idRootAdjust = responseLink.id;
          }
        }
      }
      // // Nếu là điều chỉnh giảm
      // if (isAdjustDecrease) {
      //   responseAdjustLimit = yield call(
      //     IssueInvoiceService.getAdjustLimit,
      //     idRootAdjust
      //   );
      //   response.limit =
      //     Number(responseAdjustLimit.limit) - invoiceAdjustUpdateLimit;
      // }
      yield put(getDetailTaxDeductsSuccess(response));
    } else {
      yield put(getDetailTaxDeductsFail("Lỗi"));
    }
  } catch (error) {
    yield put(getDetailTaxDeductsFail(error));
  }
}

function* fetchCreateTaxDeducts({ data }) {
  try {
    let { buStoreHeader } = yield select(state => state.Dashboard);
    const response = yield call(
      formatDataService.createTaxDeducts,
      data,
      buStoreHeader
    );
    // Wait XML generate
    yield sleep(1);
    yield put(createTaxDeductsSuccess(response));
  } catch (error) {
    yield put(createTaxDeductsFail(error));
  }
}

function* fetchEditTaxDeducts({ data, id }) {
  try {
    const response = yield call(formatDataService.editTaxDeducts, data, id);
    yield put(editTaxDeductsSuccess(response));
  } catch (error) {
    yield put(editTaxDeductsFail(error));
  }
}

function* fetchDeleteTaxDeducts({ id }) {
  try {
    const response = yield call(formatDataService.deleteTaxDeducts, id);
    yield put(deleteTaxDeductsSuccess(response));
  } catch (error) {
    yield put(deleteTaxDeductsFail(error));
  }
}

function* fetchCancelTaxDeducts({ ids }) {
  try {
    const response = yield call(formatDataService.cancelTaxDeducts, ids);
    if (response?.result) {
      yield put(cancelTaxDeductsSuccess(response));
    } else {
      yield put(cancelTaxDeductsFail());
    }
  } catch (error) {
    yield put(cancelTaxDeductsFail(error));
  }
}

function* fetchReleaseTaxDeducts({ id }) {
  try {
    const response = yield call(formatDataService.releaseRegistryDelegates, id);
    if (response.result) {
      // Wait
      yield sleep(1);
      yield put(releaseTaxDeductsSuccess());
    } else {
      yield put(releaseTaxDeductsFail("Gửi phát hành tờ khai thất bại"));
    }
  } catch (error) {
    yield put(releaseTaxDeductsFail("Gửi phát hành tờ khai thất bại"));
  }
}

function* fetchDownloadXmlTaxDeducts({
  resource_id,
  fileDownloadName,
  responseType = "blob",
}) {
  try {
    console.log("🚀 ~ fetchDownloadXmlTaxDeducts :", { resource_id, fileDownloadName });
    const response = yield call(
      formatDataService.downloadFileXMLTaxDeducts,
      resource_id,
      responseType
    );
    // console.log("fetchDownloadXmlTaxDeducts", response);
    if (response) {
      if (responseType === "blob") {
        if (
          response.size > 0 &&
          response.size !== undefined &&
          response.size !== null
        ) {
          const file = URL.createObjectURL(response);

          yield put(
            downloadXmlTaxDeductsSuccess(null, file, fileDownloadName + ".xml")
          );
        } else {
          yield put(downloadXmlTaxDeductsFail("Download file thất bại"));
        }
      } else {
        // console.log("base64_encode", Buffer.from(response).toString("base64"));
        yield put(
          downloadXmlTaxDeductsSuccess(
            Buffer.from(response).toString("base64"),
            null,
            fileDownloadName + ".xml"
          )
        );
      }
      //   yield put(downloadXmlTaxDeductsSuccess(response, null, null));
    } else {
      yield put(downloadXmlTaxDeductsFail("Download file thất bại"));
    }
  } catch (error) {
    yield put(downloadXmlTaxDeductsFail(error));
  }
}

function* fetchGetTaxDeductsRegistry({ params }) {
  try {
    // console.log("fetchGetListUpload");
    // console.log("params", params);
    // Param
    const perPage = params.sizePerPage;
    const page = params.page;
    const columnFilter = params.columnFilter;
    const keywords = params.keywords;
    const sort = params.sort;
    let { finalListBuCode, listBuOfTenant, buStoreHeader, buTenantHeaderInfo } =
      yield select(state => state.Dashboard);
    let bu_parent = undefined;
    let bu_code = undefined;
    if (buStoreHeader === ALL_STORE) {
      bu_parent = buTenantHeaderInfo.id;
    } else if (buStoreHeader === ALL_BU) {
      bu_parent = listBuOfTenant
        .filter(item => item.id)
        .map(item => item.id)
        .join(",");
    } else {
      bu_code = buStoreHeader;
    }
    // Call api
    const response = yield call(
      formatDataService.listTaxDeductsRegistry,
      page,
      perPage,
      columnFilter,
      keywords,
      sort,
      bu_code,
      bu_parent
    );
    const totalCount = response._meta.totalCount;
    // console.log("response", response);
    yield put(getListTaxDeductsRegistrySuccess(response.items, totalCount));
  } catch (error) {
    yield put(getListTaxDeductsRegistryFail(error));
  }
}

function* fetchGetDetailTaxDeductsRegistry({ id }) {
  try {
    const response = yield call(formatDataService.detailTaxDeductsRegistry, id);
    // console.log("response", response);
    yield put(getDetailTaxDeductsRegistrySuccess(response));
  } catch (error) {
    yield put(getDetailTaxDeductsRegistryFail(error));
  }
}

function* fetchCreateTaxDeductsRegistry({ data }) {
  try {
    let { buStoreHeader } = yield select(state => state.Dashboard);
    const response = yield call(
      formatDataService.createTaxDeductsRegistry,
      data,
      buStoreHeader
    );
    // Wait XML generate
    yield sleep(1);
    yield put(createTaxDeductsRegistrySuccess(response));
  } catch (error) {
    yield put(createTaxDeductsRegistryFail(error));
  }
}

function* fetchEditTaxDeductsRegistry({ data, id }) {
  try {
    const response = yield call(
      formatDataService.editTaxDeductsRegistry,
      data,
      id
    );
    yield put(editTaxDeductsRegistrySuccess(response));
  } catch (error) {
    yield put(editTaxDeductsRegistryFail(error));
  }
}

function* fetchDeleteTaxDeductsRegistry({ id }) {
  try {
    const response = yield call(formatDataService.deleteTaxDeductsRegistry, id);
    yield put(deleteTaxDeductsRegistrySuccess(response));
  } catch (error) {
    yield put(deleteTaxDeductsRegistryFail(error));
  }
}

function* fetchReleaseTaxDeductsRegistry({ id }) {
  try {
    const response = yield call(
      formatDataService.releaseTaxDeductsRegistry,
      id
    );
    if (response.result) {
      // Wait
      yield sleep(1);
      yield put(releaseTaxDeductsRegistrySuccess());
    } else {
      yield put(
        releaseTaxDeductsRegistryFail("Gửi phát hành tờ khai thất bại")
      );
    }
  } catch (error) {
    yield put(releaseTaxDeductsRegistryFail("Gửi phát hành tờ khai thất bại"));
  }
}

function* fetchDownloadXmlTaxDeductsRegistry({
  resource_id,
  fileDownloadName,
  responseType = "blob",
}) {
  try {
    const response = yield call(
      formatDataService.downloadFileXMLTaxDeductsRegistry,
      resource_id,
      responseType
    );
    // console.log("fetchDownloadXmlTaxDeductsRegistry", response);
    if (response) {
      if (responseType === "blob") {
        if (
          response.size > 0 &&
          response.size !== undefined &&
          response.size !== null
        ) {
          const file = URL.createObjectURL(response);

          yield put(
            downloadXmlTaxDeductsRegistrySuccess(
              null,
              file,
              fileDownloadName + ".xml"
            )
          );
        } else {
          yield put(
            downloadXmlTaxDeductsRegistryFail("Download file thất bại")
          );
        }
      } else {
        // console.log("base64_encode", Buffer.from(response).toString("base64"));
        yield put(
          downloadXmlTaxDeductsRegistrySuccess(
            Buffer.from(response).toString("base64"),
            null,
            fileDownloadName + ".xml"
          )
        );
      }
      //   yield put(downloadXmlTaxDeductsRegistrySuccess(response, null, null));
    } else {
      yield put(downloadXmlTaxDeductsRegistryFail("Download file thất bại"));
    }
  } catch (error) {
    yield put(downloadXmlTaxDeductsRegistryFail(error));
  }
}

function* dataFormatSaga() {
  yield takeEvery(CHECK_INVOICES_CURRENT, checkInvoicesCurrent);
  yield takeEvery(GET_LIST_REGISTRY_INVOICES, fetchGetRegistryInvoices);
  yield takeEvery(GET_LIST_REGISTRY_DELEGATE, fetchGetRegistryDelegate);
  yield takeEvery(GET_LIST_REQUEST_INVOICE_CODE, fetchGetRequestInvoiceCodes);

  yield takeEvery(GET_DETAIL_REGISTRY_INVOICES, fetchGetDetailRegistryInvoices);
  yield takeEvery(CREATE_REGISTRY_INVOICES, fetchCreateRegistryInvoices);
  yield takeEvery(EDIT_REGISTRY_INVOICES, fetchEditRegistryInvoices);

  yield takeEvery(GET_DETAIL_REGISTRY_DELEGATE, fetchGetDetailRegistryDelegate);
  yield takeEvery(CREATE_REGISTRY_DELEGATE, fetchCreateRegistryDelegate);
  yield takeEvery(EDIT_REGISTRY_DELEGATE, fetchEditRegistryDelegate);

  yield takeEvery(
    GET_DETAIL_REQUEST_INVOICE_CODE,
    fetchGetDetailRequestInvoiceCode
  );
  yield takeEvery(CREATE_REQUEST_INVOICE_CODE, fetchCreateRequestInvoiceCode);
  yield takeEvery(EDIT_REQUEST_INVOICE_CODE, fetchEditRequestInvoiceCode);

  yield takeEvery(
    DOWNLOAD_XML_REGISTRY_INVOICES,
    fetchDownloadXmlRegistryInvoices
  );
  yield takeEvery(
    DOWNLOAD_PDF_REGISTRY_INVOICES,
    fetchDownloadPDFRegistryInvoices
  );

  yield takeEvery(
    DOWNLOAD_XML_REGISTRY_DELEGATE,
    fetchDownloadXmlRegistryDelegate
  );
  yield takeEvery(
    DOWNLOAD_XML_REQUEST_INVOICE_CODE,
    fetchDownloadXmlRequestInvoiceCode
  );
  yield takeEvery(PREVIEW_PDF_REGISTER_INVOICE, fetchPreviewPdfRegisterInvoice);
  yield takeEvery(RELEASE_REGISTRY_INVOICES, fetchReleaseRegistryInvoices);
  yield takeEvery(RELEASE_REGISTRY_DELEGATE, fetchReleaseRegistryDelegates);
  yield takeEvery(PREVIEW_PDF, fetchPreviewPdf);
  yield takeEvery(
    RELEASE_REQUEST_INVOICE_CODE,
    fetchReleaseRequestInvoiceCodes
  );
  yield takeEvery(TRANSFER_USB, fetchTransferUsb);
  yield takeEvery(GET_REASON_DENY_RELEASE, fetchGetReasonDenyRelease);
  yield takeEvery(GET_HISTORY_TRANSFER, fetchGetHistoryTransfer);

  yield takeEvery(GET_LIST_TAX_DEDUCTS, fetchGetTaxDeducts);
  yield takeEvery(GET_DETAIL_TAX_DEDUCTS, fetchGetDetailTaxDeducts);
  yield takeEvery(CREATE_TAX_DEDUCTS, fetchCreateTaxDeducts);
  yield takeEvery(EDIT_TAX_DEDUCTS, fetchEditTaxDeducts);
  yield takeEvery(DELETE_TAX_DEDUCTS, fetchDeleteTaxDeducts);
  yield takeEvery(CANCEL_TAX_DEDUCTS, fetchCancelTaxDeducts);
  yield takeEvery(RELEASE_TAX_DEDUCTS, fetchReleaseTaxDeducts);
  yield takeEvery(DOWNLOAD_XML_TAX_DEDUCTS, fetchDownloadXmlTaxDeducts);

  yield takeEvery(GET_LIST_TAX_DEDUCTS_REGISTRY, fetchGetTaxDeductsRegistry);
  yield takeEvery(
    GET_DETAIL_TAX_DEDUCTS_REGISTRY,
    fetchGetDetailTaxDeductsRegistry
  );
  yield takeEvery(CREATE_TAX_DEDUCTS_REGISTRY, fetchCreateTaxDeductsRegistry);
  yield takeEvery(EDIT_TAX_DEDUCTS_REGISTRY, fetchEditTaxDeductsRegistry);
  yield takeEvery(DELETE_TAX_DEDUCTS_REGISTRY, fetchDeleteTaxDeductsRegistry);
  yield takeEvery(RELEASE_TAX_DEDUCTS_REGISTRY, fetchReleaseTaxDeductsRegistry);
  yield takeEvery(
    DOWNLOAD_XML_TAX_DEDUCTS_REGISTRY,
    fetchDownloadXmlTaxDeductsRegistry
  );
}

export default dataFormatSaga;
